import { Box, Skeleton } from '@mui/material'

/**
 * Generic Page Skeleton Component
 *
 * A simple skeleton for pages where we don't know the specific layout.
 * Shows breadcrumbs, title, and a content area placeholder.
 */
export const PageSkeleton = () => {
  return (
    <Box sx={{ p: 3, height: '100%', display: 'flex', flexDirection: 'column' }}>
      {/* Breadcrumbs area */}
      <Box sx={{ mb: 2, display: 'flex', alignItems: 'center', gap: 1 }}>
        <Skeleton animation="wave" variant="text" width={80} height={24} />
        <Skeleton animation="wave" variant="text" width={16} height={24} />
        <Skeleton animation="wave" variant="text" width={100} height={24} />
      </Box>

      {/* Page title */}
      <Skeleton animation="wave" variant="text" width={200} height={40} sx={{ mb: 3 }} />

      {/* Content area - generic card-like placeholders */}
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, flex: 1 }}>
        <Skeleton animation="wave" variant="rounded" width="100%" height={120} />
        <Skeleton animation="wave" variant="rounded" width="100%" height={200} />
        <Skeleton animation="wave" variant="rounded" width="60%" height={80} />
      </Box>
    </Box>
  )
}

export default PageSkeleton
